import React, { ReactNode } from "react"
import clsx from "clsx"
import { Box, Row } from "ui/components/atoms/_atoms"
import Icon from "ui/components/atoms/icon"

import styles from "./SelectRow.module.css"

const SelectRow = ({
  checked,
  label,
  value,
  onClick,
  disabled = false,
  $showBorder = true,
  $withBackground = false,
}: {
  checked: boolean
  label: ReactNode
  value?: ReactNode
  onClick: () => void
  disabled?: boolean
  $showBorder?: boolean
  $withBackground?: boolean
}) => {
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.disabled]: disabled,
        [styles.showBorder]: $showBorder,
        [styles.withBackground]: $withBackground,
      })}
    >
      <div
        className={clsx(styles.checkWrapper, {
          [styles.active]: !disabled && checked,
          [styles.disabled]: disabled,
        })}
        onClick={disabled ? () => {} : onClick}
      >
        <Icon icon="check" $size="10px" $opacity={checked ? 1 : 0} $color="white" />
      </div>
      <Row
        className={styles.content}
        $flex={1}
        $alignItems="center"
        $justifyContent="space-between"
        $marginLeft="XS"
        $opacity={disabled ? 0.6 : 1}
      >
        <Box $width="100%" $flex={1}>
          {label}
        </Box>
        {value && <Box>{value}</Box>}
      </Row>
    </div>
  )
}

export default SelectRow
